import React from 'react';
import { useSelector } from 'react-redux';
import { isMobileSelector } from 'common/selectors';

import { DesktopBreadcrumbsDecorated } from './DesktopBreadcrumbs';
import { MobileBreadcrumbsDecorated } from './MobileBreadcrumbs';

export const Breadcrumbs = () => {
  const isMobile = useSelector(isMobileSelector);
  return isMobile ? <MobileBreadcrumbsDecorated /> : <DesktopBreadcrumbsDecorated />;
};
